import { render, staticRenderFns } from "./imago.vue?vue&type=template&id=1a9d3cb7&scoped=true&"
import script from "./imago.vue?vue&type=script&lang=js&"
export * from "./imago.vue?vue&type=script&lang=js&"
import style0 from "./imago.vue?vue&type=style&index=0&id=1a9d3cb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9d3cb7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VHover,VImg,VProgressCircular})
